'use client';

import { ChangeEvent, FormEvent } from 'react';
import { LoadingIndicator } from '@wishket/design-system';
import { usePathname, useRouter } from 'next/navigation';

import { Habit, useNewsLetterSetting } from './useNewsLetterSetting';

import { NotificationNewsLetterForm } from '@/features/NotificationSettings';
import { useOnBoardingStatusMutation } from '@/entities/profile';
import { PATH } from '@/shared/constants';

type Item = {
  key: number | string;
  value: string;
  leadingIcon?: string;
};

interface OnBoardingNewLetterSettingProps {
  onClose: () => void;
}

const OnBoardingNewLetterSetting = ({
  onClose,
}: OnBoardingNewLetterSettingProps) => {
  const { data, onChange, autoSetTime, mutate, isLoading } =
    useNewsLetterSetting();
  const { mutate: onBoardingEnd } = useOnBoardingStatusMutation();
  const pathname = usePathname();
  const pathWithoutTrailingSlash = pathname.replace(/\/$/, '');
  const isLandingPage =
    pathWithoutTrailingSlash === PATH.HOME || pathWithoutTrailingSlash === '';
  const router = useRouter();

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onBoardingEnd();
    onClose();

    if (isLandingPage) {
      router.refresh(); // 회원 랜딩을 보여주기 위해 페이지 새로고침
    }
  };

  const handleHabit = (e: ChangeEvent<HTMLInputElement>) => {
    onChange.habit(e);
    mutate({
      title: e.target.value as Habit,
      time: Number(autoSetTime(e.target.value as Habit)),
    });
  };

  const handleTime = (e: Item) => {
    onChange.time(e);
    mutate({ time: Number(e.key) });
  };

  if (isLoading) return <LoadingIndicator />;

  return (
    <NotificationNewsLetterForm
      isOnBoarding
      data={data}
      onChange={{ habit: handleHabit, time: handleTime }}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  );
};

export default OnBoardingNewLetterSetting;
